import Vue from "./../init";

const uri = "user/bgslt{/id}";

var customActions = {
  regenerate: { method: "POST", url: uri + "/regenerate" }
};

export const BGSLTResource = Vue.resource(uri, {}, customActions);
